module.exports = __webpack_public_path__ + "img/introducePageFour_show_eight.c404f3fc.jpg";